import { useQuery } from "@tanstack/react-query";
import { api } from "./api/client.js";

/**
 * Optional parts of the product this deployment offers. Until the answer arrives everything
 * optional stays hidden (sign-up included), so a switched-off feature never flashes on screen;
 * `loaded` tells the pages that say "closed" apart from those still waiting. It also turns true
 * when the request fails for good, so nothing stays hidden forever; everything optional is off.
 */
export function useFeatures() {
  const features = useQuery({
    queryKey: ["features"],
    queryFn: () => api.features(),
    staleTime: Number.POSITIVE_INFINITY,
  });
  return {
    domainSales: features.data?.domainSales ?? false,
    ai: features.data?.ai ?? false,
    signup: features.data?.signup ?? false,
    loaded: !features.isPending,
  };
}
